import { function_TODOS_Parametros_Listar } from "./TODOS_Parametros";
import * as XLSX from 'xlsx';

export function FechaHoraActual() {
    let fechaFormateada;

    try {
        const fecha = new Date();

        const dia = fecha.getDate().toString().padStart(2, '0');
        const mes = (fecha.getMonth() + 1).toString().padStart(2, '0'); // Los meses van de 0 a 11, por lo que se suma 1
        const anio = fecha.getFullYear().toString();

        const hora = fecha.getHours().toString().padStart(2, '0');
        const minutos = fecha.getMinutes().toString().padStart(2, '0');
        const segundos = fecha.getSeconds().toString().padStart(2, '0');

        fechaFormateada = `${dia}/${mes}/${anio} ${hora}:${minutos}:${segundos}`;

    } catch (error) {
        throw error;
    }

    return fechaFormateada;
}

export function FechaHoraActual_yyyyMMdd_HHmmss() {
    let fechaFormateada;

    try {
        const fecha = new Date();

        const dia = fecha.getDate().toString().padStart(2, '0');
        const mes = (fecha.getMonth() + 1).toString().padStart(2, '0'); // Los meses van de 0 a 11, por lo que se suma 1
        const anio = fecha.getFullYear().toString();

        const hora = fecha.getHours().toString().padStart(2, '0');
        const minutos = fecha.getMinutes().toString().padStart(2, '0');
        const segundos = fecha.getSeconds().toString().padStart(2, '0');

        fechaFormateada = `${anio}${mes}${dia} ${hora}${minutos}${segundos}`;

    } catch (error) {
        throw error;
    }

    return fechaFormateada;
}

export function FechaHoraActual_yyyyMMdd() {
    let fechaFormateada;

    try {
        const fecha = new Date();

        const dia = fecha.getDate().toString().padStart(2, '0');
        const mes = (fecha.getMonth() + 1).toString().padStart(2, '0'); // Los meses van de 0 a 11, por lo que se suma 1
        const anio = fecha.getFullYear().toString();

        fechaFormateada = `${anio}${mes}${dia}`;

    } catch (error) {
        throw error;
    }

    return fechaFormateada;
}

export function FormateoFechaPara_yyyyMMdd(Fecha) {
    let fechaFormateada

    try {
        if (typeof Fecha === 'undefined' || Fecha === '' || Fecha === null) {

        }
        else {
            const anio = Fecha.getFullYear();
            const mes = (Fecha.getMonth() + 1).toString().padStart(2, '0');
            const dia = Fecha.getDate().toString().padStart(2, '0');

            fechaFormateada = `${anio}${mes}${dia}`;
        }
    } catch (error) {
        throw error;
    }

    return fechaFormateada;
}

export function FormateoFechaPara_yyyyMMdd_HHmmss(Fecha) {
    let fechaFormateada

    try {
        if (typeof Fecha === 'undefined' || Fecha === '' || Fecha === null) {

        }
        else {
            const anio = Fecha.getFullYear();
            const mes = (Fecha.getMonth() + 1).toString().padStart(2, '0');
            const dia = Fecha.getDate().toString().padStart(2, '0');

            const hours = String(Fecha.getHours()).padStart(2, '0');
            const minutes = String(Fecha.getMinutes()).padStart(2, '0');
            const seconds = String(Fecha.getSeconds()).padStart(2, '0');

            fechaFormateada = `${anio}${mes}${dia} ${hours}${minutes}${seconds}`;
        }
    } catch (error) {
        throw error;
    }

    return fechaFormateada;
}

export function FormateoFechaPara_ddMMyyyy_HHmm(Fecha) {
    const FechaConTresHoras = new Date(Fecha);

    const day = String(FechaConTresHoras.getDate()).padStart(2, '0');
    const month = String(FechaConTresHoras.getMonth() + 1).padStart(2, '0'); // Enero es 0
    const year = FechaConTresHoras.getFullYear();
    const hours = String(FechaConTresHoras.getHours()).padStart(2, '0');
    const minutes = String(FechaConTresHoras.getMinutes()).padStart(2, '0');

    return `${day}/${month}/${year} ${hours}:${minutes}`;
};

export function FormateoFechaPara_ddMMyyyy(Fecha) {
    const FechaConTresHoras = new Date(Fecha);

    const day = String(FechaConTresHoras.getDate()).padStart(2, '0');
    const month = String(FechaConTresHoras.getMonth() + 1).padStart(2, '0'); // Enero es 0
    const year = FechaConTresHoras.getFullYear();

    return `${day}/${month}/${year}`;
};

export function TratamientoDeVariableString(Variable) {
    try {
        let variableComoString = String(Variable)
        let VariableReemplazado = variableComoString

        if (typeof VariableReemplazado === 'string') {
            if (VariableReemplazado === "NADA") {
                VariableReemplazado = "";
            }

            if (VariableReemplazado === "NA*DA") {
                VariableReemplazado = "";
            }

            if (VariableReemplazado.includes("%20")) {
                VariableReemplazado = VariableReemplazado.replace(/%20/g, " ");
            } else {
                VariableReemplazado = VariableReemplazado;
            }

            if (VariableReemplazado.includes("%2F")) {
                VariableReemplazado = VariableReemplazado.replace(/%2F/g, "/");
            } else {
                VariableReemplazado = VariableReemplazado;
            }

            if (VariableReemplazado.includes("%22")) {
                VariableReemplazado = VariableReemplazado.replace(/%22/g, '"');
            } else {
                VariableReemplazado = VariableReemplazado;
            }

            if (VariableReemplazado.includes("%27")) {
                VariableReemplazado = VariableReemplazado.replace(/%27/g, "'");
            } else {
                VariableReemplazado = VariableReemplazado;
            }

            if (VariableReemplazado.includes("%2A")) {
                VariableReemplazado = VariableReemplazado.replace(/%2A/g, "*");
            } else {
                VariableReemplazado = VariableReemplazado;
            }

            if (VariableReemplazado.includes("%25")) {
                VariableReemplazado = VariableReemplazado.replace(/%25/g, "%");
            } else {
                VariableReemplazado = VariableReemplazado;
            }
        }
        return VariableReemplazado;
    } catch (error) {
        throw error;
    }
}

export function TratamientoDeVariableBoolean(Variable) {
    try {
        if (typeof Variable === 'boolean') {
            return Variable;
        }

        if (typeof Variable === 'string') {
            // Convertir la cadena a minúsculas y comparar con 'true'
            return Variable.toLowerCase() === 'true' || Variable === '1';
        }

        return typeof Variable === 'number' && Variable === 1;
    } catch (error) {
        throw error;
    }
}

export function IdentificacionDePorcentaje(Porcentaje) {
    let Porc = 0;

    try {
        if (Porcentaje > 23) {
            Porc = 27;
        }
        else if (Porcentaje <= 23 && Porcentaje > 15) {
            Porc = 21;
        }
        else if (Porcentaje <= 15 && Porcentaje > 9) {
            Porc = 10.5;
        }
        else if (Porcentaje <= 9 && Porcentaje > 4) {
            Porc = 5;
        }
        else if (Porcentaje <= 4 && Porcentaje > 0) {
            Porc = 2.5;
        }
        else {
            Porc = 0;
        }
    } catch (error) {
        throw error;
    }

    return Porc;
}

export function ObtienePorcentajeIVAConNetoIVA(Neto, IVA) {
    let Total = 0;

    try {
        if (Neto != 0 && IVA != 0) {
            let Porcentaje = IVA * 100 / Neto;// (((Neto + IVA) / Neto) - 1) * 100;
            Total = IdentificacionDePorcentaje(Porcentaje);
        }
    } catch (error) {
        throw error;
    }

    return Total;
}

export function ObtienePorcentajeIVAConTotalIVA(ImpTotal, IVA) {
    let Total = 0;

    try {
        if (ImpTotal != 0 && IVA != 0) {
            let Porcentaje = ((ImpTotal / (ImpTotal - IVA)) - 1) * 100;
            Total = IdentificacionDePorcentaje(Porcentaje);
        }
    } catch (error) {
        throw error;
    }

    return Total;
}

export function ObtienePorcentajeIVAConTotalNeto(ImpTotal, Neto) {
    let Total = 0;

    try {
        if (ImpTotal != 0 && Neto != 0) {
            let Porcentaje = ((ImpTotal / Neto) - 1) * 100;
            Total = IdentificacionDePorcentaje(Porcentaje);
        }
    } catch (error) {
        throw error;
    }

    return Total;
}

export function ObtieneNetoConTotalPorcentajeIVA(ImpTotal, PorcentajeIVA) {
    let Neto = 0;

    try {
        if (ImpTotal != 0 && PorcentajeIVA > 0) {
            Neto = ImpTotal / (1 + PorcentajeIVA / 100);
        }
    } catch (error) {
        throw error;
    }

    return Neto;
}

export async function ObtieneParametros() {

    let CodigoArticuloComisionMercadoPago
    let CodigoArticuloEnvioMercadoPago
    let CodigoCuentaFinancieraMercadoPago
    let CodigoDepositoParaReservasDePedidosDeVenta
    let CodigoPresentacionComisionMercadoPago
    let CodigoSubCCComisionMercadoPago
    let CodigoTamanoComisionMercadoPago
    let CodigoUnidadMedidaComisionMercadoPago
    let ComprasComisionesArticulo
    let ComprasComisionesPresentacion
    let ComprasComisionesSubCC
    let ComprasComisionesTamano
    let ComprasComisionesUbicacion
    let ComprasComisionesUnidadMedida
    let ComprasConContabilidad
    let ComprasConCosteo
    let ComprasConDetalle
    let ComprasConImpuestos
    let ComprasConObservaciones
    let ComprasConProveedor
    let ComprasNCConContabilidad
    let ComprasNCConCosteo
    let ComprasNCConDetalle
    let ComprasNCConImpuestos
    let ComprasNCConObservaciones
    let ComprasNCConProveedor
    let ComprasNDConContabilidad
    let ComprasNDConCosteo
    let ComprasNDConDetalle
    let ComprasNDConImpuestos
    let ComprasNDConObservaciones
    let ComprasNDConProveedor
    let ComprasPermiteDocsCompraSinPagoDesdePC
    let ComprasPermitePagoConImporteDiferenteAlDocCompraDesdePC
    let ContabilidadConAsientos
    let ContabilidadConvenioMultilateral
    let ContabilidadIVA10ComprasCodigoCuentaContable
    let ContabilidadIVA10VentasCodigoCuentaContable
    let ContabilidadIVA21ComprasCodigoCuentaContable
    let ContabilidadIVA21VentasCodigoCuentaContable
    let ContabilidadIVA27ComprasCodigoCuentaContable
    let ContabilidadIVA27VentasCodigoCuentaContable
    let ContabilidadPercepcionesIIBBPorPadron
    let ContabilidadRetencionesIIBBPorPadron
    let CorreoAEnviarConfirmacionLectura
    let CorreoAEnviarCopia
    let CorreoEmisor
    let CotizacionesConCliente
    let CotizacionesConDetalle
    let CotizacionesConImpuestos
    let CotizacionesConObservaciones
    let DesconectadoActualizaSiempreAlIngresar
    let EnProcesoDeSincronizacioConDesconectados
    let EnProcesoDeSincronizacioConNube
    let GlobalAdminSinAjusteDeInventario
    let GlobalCantidadBuscadorFiltro
    let GlobalCantidadListadosMaestros
    let GlobalCantidadListadosOperaciones
    let GlobalCierraVentanasAlFinalizarEdicion
    let GlobalConAuditoria
    let GlobalConPacientes
    let GlobalControlHorarioClientesRequiereSalida
    let GlobalControlHorarioPersonasRequiereSalida
    let GlobalDiasGraciaDeBorradoRemitos
    let GlobalDigitosDeVisualizacionEnCantidadesDeCompra
    let GlobalDigitosDeVisualizacionEnCantidadesDeVenta
    let GlobalEstiloColores
    let GlobalEstiloColoresPersonalizado
    let GlobalFechaBloqueadaDocsCompra
    let GlobalFechaBloqueadaDocsVenta
    let GlobalFechaBloqueadaPagos
    let GlobalFechaBloqueadaRecibos
    let GlobalFechaBloqueadaRemitos
    let GlobalFechaReportes
    let GlobalFechaUltimoBackUp
    let GlobalMonedaBase
    let GlobalMonedaReferente
    let GlobalNoFiltraHastaNoPresionarActualizar
    let GlobalPathBackUp
    let GlobalPrefijoCodigoBarras
    let GlobalRemitosTransferenciaSeGeneranPendientesDeConfirmar
    let GlobalSoloAdminBorraEditaDocsCompra
    let GlobalSoloAdminBorraEditaDocsVenta
    let GlobalSoloAdminBorraEditaPagos
    let GlobalSoloAdminBorraEditaRecibos
    let GlobalSoloAdminBorraEditaRemitos
    let GlobalToleranciaDeRedondeoEnOperaciones
    let GlobalUsaArticulosConCodigoEnLasGrillas
    let GlobalUsaArticulosConPresentacion
    let GlobalUsaArticulosConTamano
    let GlobalUsaArticulosConUnidadDeMedida
    let GlobalVersionMasAltaLogeada
    let IdProveedorMercadoPago
    let IntervaloDeSincronizacion
    let InventarioSinStockNegativo
    let ListasDePreciosConImportesEnUMBasica
    let PagosAutorizacionPreviaDeDocCompra
    let PagosConContabilidad
    let PagosConImpuestos
    let PagosConObservaciones
    let Password
    let PedidosConCliente
    let PedidosConDetalle
    let PedidosConImpuestos
    let PedidosConObservaciones
    let PedidosConPosibilidadDeAbono
    let PedidosPV1_UltimoGenerado
    let PedidosPV2_UltimoGenerado
    let PedidosPV3_UltimoGenerado
    let PedidosPV4_UltimoGenerado
    let PedidosPV5_UltimoGenerado
    let PedidosPV6_UltimoGenerado
    let PedidosPV7_UltimoGenerado
    let PedidosPV8_UltimoGenerado
    let PedidosPV9_UltimoGenerado
    let PedidosTiempoDeBorradoParaPedidosSinConfirmar
    let PedidosValorizados
    let PermiteCrearRemitosDesdeVentas
    let Port
    let ProduccionCreaOTCuandoCreoPedido
    let ProduccionFabricacionImprimeEtiquetas
    let RecibosConContabilidad
    let RecibosConImpuestos
    let RecibosConObservaciones
    let RecibosPV1_UltimoGenerado
    let RecibosPV2_UltimoGenerado
    let RecibosPV3_UltimoGenerado
    let RecibosPV4_UltimoGenerado
    let RecibosPV5_UltimoGenerado
    let RecibosPV6_UltimoGenerado
    let RecibosPV7_UltimoGenerado
    let RecibosPV8_UltimoGenerado
    let RecibosPV9_UltimoGenerado
    let RemitosPV1_UltimoGenerado
    let RemitosPV2_UltimoGenerado
    let RemitosPV3_UltimoGenerado
    let RemitosPV4_UltimoGenerado
    let RemitosPV5_UltimoGenerado
    let RemitosPV6_UltimoGenerado
    let RemitosPV7_UltimoGenerado
    let RemitosPV8_UltimoGenerado
    let RemitosPV9_UltimoGenerado
    let RemitosValorizados
    let Server
    let SincronizaConDispositivosDesconectados
    let SincronizaConNube
    let UltimaSincronizacion
    let UltimaSubidaALaNube
    let Usuario
    let VentasBajaStockEnPuntoDeVentaSinImportarParametrizacionDeArticulo
    let VentasClienteConsumidorFinal
    let VentasCodigoArticuloFaltanteDeCaja
    let VentasCodigoArticuloSobranteDeCaja
    let VentasConCliente
    let VentasConContabilidad
    let VentasConCosteo
    let VentasConDetalle
    let VentasConImpuestos
    let VentasConObservaciones
    let VentasCorreoDocVentaEnviaDetalleDeDeuda
    let VentasDesactivaCuentasFinancierasManualesSiFormaPagoNoEsEfectivo
    let VentasDigitosDeRedondeoEnLPPorcentuales
    let VentasImporteGastadoParaObtenerUnPunto
    let VentasImpresionDeFacturaElectronicaPorComandera
    let VentasImprimeSinPreguntar
    let VentasImprimeTicketsComanderasEnArchivo
    let VentasListaPreciosParaPuntoVenta
    let VentasNCConCliente
    let VentasNCConContabilidad
    let VentasNCConCosteo
    let VentasNCConDetalle
    let VentasNCConImpuestos
    let VentasNCConObservaciones
    let VentasNDConCliente
    let VentasNDConContabilidad
    let VentasNDConCosteo
    let VentasNDConDetalle
    let VentasNDConImpuestos
    let VentasNDConObservaciones
    let VentasObtienePrecioSugeridoDeVentaDesdeCosto
    let VentasPedidosCodigoUbicacionReservaStock
    let VentasPedidosUsaReservaStock
    let VentasPermiteDocsVentaSinReciboDesdePV
    let VentasPermiteReciboConImporteDiferenteAlDocVentaDesdePV
    let VentasPV1_UltimoGenerado
    let VentasPV2_UltimoGenerado
    let VentasPV3_UltimoGenerado
    let VentasPV4_UltimoGenerado
    let VentasPV5_UltimoGenerado
    let VentasPV6_UltimoGenerado
    let VentasPV7_UltimoGenerado
    let VentasPV8_UltimoGenerado
    let VentasPV9_UltimoGenerado
    let VentasPVArticulosConPeso
    let VentasPVArticulosPuedeAbrirBuscador
    let VentasPVConDatosExtraAlCrearCliente
    let VentasPVConGrupoDetalleDeVentas
    let VentasPVConGrupoVerificaciones
    let VentasPVConTransferenciasAutomaticas
    let VentasPVFESinValidarLeyenda
    let VentasPVFESinValidarPermiteImprimir
    let VentasPVPermiteVenderConPrecioCero
    let VentasPVPermiteVisualizarEfectivoDeCaja
    let VentasPVProveedorDelivery1
    let VentasPVProveedorDelivery1Activo
    let VentasPVProveedorDelivery1CantidadDigitos
    let VentasPVProveedorDelivery1CuentaFinanciera
    let VentasPVProveedorDelivery1ListaDePrecios
    let VentasPVProveedorDelivery2
    let VentasPVProveedorDelivery2Activo
    let VentasPVProveedorDelivery2CantidadDigitos
    let VentasPVProveedorDelivery2CuentaFinanciera
    let VentasPVProveedorDelivery2ListaDePrecios
    let VentasPVProveedorDelivery3
    let VentasPVProveedorDelivery3Activo
    let VentasPVProveedorDelivery3CantidadDigitos
    let VentasPVProveedorDelivery3CuentaFinanciera
    let VentasPVProveedorDelivery3ListaDePrecios
    let VentasPVProveedorDelivery4
    let VentasPVProveedorDelivery4Activo
    let VentasPVProveedorDelivery4CantidadDigitos
    let VentasPVProveedorDelivery4CuentaFinanciera
    let VentasPVProveedorDelivery4ListaDePrecios
    let VentasPVProveedorDelivery5
    let VentasPVProveedorDelivery5Activo
    let VentasPVProveedorDelivery5CantidadDigitos
    let VentasPVProveedorDelivery5CuentaFinanciera
    let VentasPVProveedorDelivery5ListaDePrecios
    let VentasPVProveedorDelivery6
    let VentasPVProveedorDelivery6Activo
    let VentasPVProveedorDelivery6CantidadDigitos
    let VentasPVProveedorDelivery6CuentaFinanciera
    let VentasPVProveedorDelivery6ListaDePrecios
    let VentasRappiEnProduccion
    let VentasRedondeoAMultiplosDeCinco
    let VentasUsaCodigosBarra
    let VentasValidaFESinPreguntar
    let VentasWebIdUsuario
    let VentasWebTerminal
    let ViafarUltimaCompraImportada

    try {
        const resultDataParametros = await function_TODOS_Parametros_Listar();

        resultDataParametros.data.forEach(parametro => {
            if (parametro.Parametro === "CodigoArticuloComisionMercadoPago") { CodigoArticuloComisionMercadoPago = parametro.Valor }
            if (parametro.Parametro === "CodigoArticuloEnvioMercadoPago") { CodigoArticuloEnvioMercadoPago = parametro.Valor }
            if (parametro.Parametro === "CodigoCuentaFinancieraMercadoPago") { CodigoCuentaFinancieraMercadoPago = parametro.Valor }
            if (parametro.Parametro === "CodigoDepositoParaReservasDePedidosDeVenta") { CodigoDepositoParaReservasDePedidosDeVenta = parametro.Valor }
            if (parametro.Parametro === "CodigoPresentacionComisionMercadoPago") { CodigoPresentacionComisionMercadoPago = parametro.Valor }
            if (parametro.Parametro === "CodigoSubCCComisionMercadoPago") { CodigoSubCCComisionMercadoPago = parametro.Valor }
            if (parametro.Parametro === "CodigoTamanoComisionMercadoPago") { CodigoTamanoComisionMercadoPago = parametro.Valor }
            if (parametro.Parametro === "CodigoUnidadMedidaComisionMercadoPago") { CodigoUnidadMedidaComisionMercadoPago = parametro.Valor }
            if (parametro.Parametro === "ComprasComisionesArticulo") { ComprasComisionesArticulo = parametro.Valor }
            if (parametro.Parametro === "ComprasComisionesPresentacion") { ComprasComisionesPresentacion = parametro.Valor }
            if (parametro.Parametro === "ComprasComisionesSubCC") { ComprasComisionesSubCC = parametro.Valor }
            if (parametro.Parametro === "ComprasComisionesTamano") { ComprasComisionesTamano = parametro.Valor }
            if (parametro.Parametro === "ComprasComisionesUbicacion") { ComprasComisionesUbicacion = parametro.Valor }
            if (parametro.Parametro === "ComprasComisionesUnidadMedida") { ComprasComisionesUnidadMedida = parametro.Valor }
            if (parametro.Parametro === "ComprasConContabilidad") { ComprasConContabilidad = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "ComprasConCosteo") { ComprasConCosteo = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "ComprasConDetalle") { ComprasConDetalle = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "ComprasConImpuestos") { ComprasConImpuestos = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "ComprasConObservaciones") { ComprasConObservaciones = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "ComprasConProveedor") { ComprasConProveedor = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "ComprasNCConContabilidad") { ComprasNCConContabilidad = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "ComprasNCConCosteo") { ComprasNCConCosteo = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "ComprasNCConDetalle") { ComprasNCConDetalle = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "ComprasNCConImpuestos") { ComprasNCConImpuestos = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "ComprasNCConObservaciones") { ComprasNCConObservaciones = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "ComprasNCConProveedor") { ComprasNCConProveedor = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "ComprasNDConContabilidad") { ComprasNDConContabilidad = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "ComprasNDConCosteo") { ComprasNDConCosteo = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "ComprasNDConDetalle") { ComprasNDConDetalle = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "ComprasNDConImpuestos") { ComprasNDConImpuestos = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "ComprasNDConObservaciones") { ComprasNDConObservaciones = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "ComprasNDConProveedor") { ComprasNDConProveedor = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "ComprasPermiteDocsCompraSinPagoDesdePC") { ComprasPermiteDocsCompraSinPagoDesdePC = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "ComprasPermitePagoConImporteDiferenteAlDocCompraDesdePC") { ComprasPermitePagoConImporteDiferenteAlDocCompraDesdePC = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "ContabilidadConAsientos") { ContabilidadConAsientos = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "ContabilidadConvenioMultilateral") { ContabilidadConvenioMultilateral = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "ContabilidadIVA10ComprasCodigoCuentaContable") { ContabilidadIVA10ComprasCodigoCuentaContable = parametro.Valor }
            if (parametro.Parametro === "ContabilidadIVA10VentasCodigoCuentaContable") { ContabilidadIVA10VentasCodigoCuentaContable = parametro.Valor }
            if (parametro.Parametro === "ContabilidadIVA21ComprasCodigoCuentaContable") { ContabilidadIVA21ComprasCodigoCuentaContable = parametro.Valor }
            if (parametro.Parametro === "ContabilidadIVA21VentasCodigoCuentaContable") { ContabilidadIVA21VentasCodigoCuentaContable = parametro.Valor }
            if (parametro.Parametro === "ContabilidadIVA27ComprasCodigoCuentaContable") { ContabilidadIVA27ComprasCodigoCuentaContable = parametro.Valor }
            if (parametro.Parametro === "ContabilidadIVA27VentasCodigoCuentaContable") { ContabilidadIVA27VentasCodigoCuentaContable = parametro.Valor }
            if (parametro.Parametro === "ContabilidadPercepcionesIIBBPorPadron") { ContabilidadPercepcionesIIBBPorPadron = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "ContabilidadRetencionesIIBBPorPadron") { ContabilidadRetencionesIIBBPorPadron = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "CorreoAEnviarConfirmacionLectura") { CorreoAEnviarConfirmacionLectura = parametro.Valor }
            if (parametro.Parametro === "CorreoAEnviarCopia") { CorreoAEnviarCopia = parametro.Valor }
            if (parametro.Parametro === "CorreoEmisor") { CorreoEmisor = parametro.Valor }
            if (parametro.Parametro === "CotizacionesConCliente") { CotizacionesConCliente = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "CotizacionesConDetalle") { CotizacionesConDetalle = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "CotizacionesConImpuestos") { CotizacionesConImpuestos = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "CotizacionesConObservaciones") { CotizacionesConObservaciones = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "DesconectadoActualizaSiempreAlIngresar") { DesconectadoActualizaSiempreAlIngresar = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "EnProcesoDeSincronizacioConDesconectados") { EnProcesoDeSincronizacioConDesconectados = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "EnProcesoDeSincronizacioConNube") { EnProcesoDeSincronizacioConNube = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "GlobalAdminSinAjusteDeInventario") { GlobalAdminSinAjusteDeInventario = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "GlobalCantidadBuscadorFiltro") { GlobalCantidadBuscadorFiltro = parametro.Valor }
            if (parametro.Parametro === "GlobalCantidadListadosMaestros") { GlobalCantidadListadosMaestros = parametro.Valor }
            if (parametro.Parametro === "GlobalCantidadListadosOperaciones") { GlobalCantidadListadosOperaciones = parametro.Valor }
            if (parametro.Parametro === "GlobalCierraVentanasAlFinalizarEdicion") { GlobalCierraVentanasAlFinalizarEdicion = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "GlobalConAuditoria") { GlobalConAuditoria = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "GlobalConPacientes") { GlobalConPacientes = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "GlobalControlHorarioClientesRequiereSalida") { GlobalControlHorarioClientesRequiereSalida = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "GlobalControlHorarioPersonasRequiereSalida") { GlobalControlHorarioPersonasRequiereSalida = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "GlobalDiasGraciaDeBorradoRemitos") { GlobalDiasGraciaDeBorradoRemitos = parametro.Valor }
            if (parametro.Parametro === "GlobalDigitosDeVisualizacionEnCantidadesDeCompra") { GlobalDigitosDeVisualizacionEnCantidadesDeCompra = parametro.Valor }
            if (parametro.Parametro === "GlobalDigitosDeVisualizacionEnCantidadesDeVenta") { GlobalDigitosDeVisualizacionEnCantidadesDeVenta = parametro.Valor }
            if (parametro.Parametro === "GlobalEstiloColores") { GlobalEstiloColores = parametro.Valor }
            if (parametro.Parametro === "GlobalEstiloColoresPersonalizado") { GlobalEstiloColoresPersonalizado = parametro.Valor }
            if (parametro.Parametro === "GlobalFechaBloqueadaDocsCompra") { GlobalFechaBloqueadaDocsCompra = parametro.Valor }
            if (parametro.Parametro === "GlobalFechaBloqueadaDocsVenta") { GlobalFechaBloqueadaDocsVenta = parametro.Valor }
            if (parametro.Parametro === "GlobalFechaBloqueadaPagos") { GlobalFechaBloqueadaPagos = parametro.Valor }
            if (parametro.Parametro === "GlobalFechaBloqueadaRecibos") { GlobalFechaBloqueadaRecibos = parametro.Valor }
            if (parametro.Parametro === "GlobalFechaBloqueadaRemitos") { GlobalFechaBloqueadaRemitos = parametro.Valor }
            if (parametro.Parametro === "GlobalFechaReportes") { GlobalFechaReportes = parametro.Valor }
            if (parametro.Parametro === "GlobalFechaUltimoBackUp") { GlobalFechaUltimoBackUp = parametro.Valor }
            if (parametro.Parametro === "GlobalMonedaBase") { GlobalMonedaBase = parametro.Valor }
            if (parametro.Parametro === "GlobalMonedaReferente") { GlobalMonedaReferente = parametro.Valor }
            if (parametro.Parametro === "GlobalNoFiltraHastaNoPresionarActualizar") { GlobalNoFiltraHastaNoPresionarActualizar = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "GlobalPathBackUp") { GlobalPathBackUp = parametro.Valor }
            if (parametro.Parametro === "GlobalPrefijoCodigoBarras") { GlobalPrefijoCodigoBarras = parametro.Valor }
            if (parametro.Parametro === "GlobalRemitosTransferenciaSeGeneranPendientesDeConfirmar") { GlobalRemitosTransferenciaSeGeneranPendientesDeConfirmar = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "GlobalSoloAdminBorraEditaDocsCompra") { GlobalSoloAdminBorraEditaDocsCompra = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "GlobalSoloAdminBorraEditaDocsVenta") { GlobalSoloAdminBorraEditaDocsVenta = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "GlobalSoloAdminBorraEditaPagos") { GlobalSoloAdminBorraEditaPagos = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "GlobalSoloAdminBorraEditaRecibos") { GlobalSoloAdminBorraEditaRecibos = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "GlobalSoloAdminBorraEditaRemitos") { GlobalSoloAdminBorraEditaRemitos = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "GlobalToleranciaDeRedondeoEnOperaciones") { GlobalToleranciaDeRedondeoEnOperaciones = parametro.Valor }
            if (parametro.Parametro === "GlobalUsaArticulosConCodigoEnLasGrillas") { GlobalUsaArticulosConCodigoEnLasGrillas = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "GlobalUsaArticulosConPresentacion") { GlobalUsaArticulosConPresentacion = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "GlobalUsaArticulosConTamaño") { GlobalUsaArticulosConTamano = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "GlobalUsaArticulosConUnidadDeMedida") { GlobalUsaArticulosConUnidadDeMedida = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "GlobalVersionMasAltaLogeada") { GlobalVersionMasAltaLogeada = parametro.Valor }
            if (parametro.Parametro === "IdProveedorMercadoPago") { IdProveedorMercadoPago = parametro.Valor }
            if (parametro.Parametro === "IntervaloDeSincronizacion") { IntervaloDeSincronizacion = parametro.Valor }
            if (parametro.Parametro === "InventarioSinStockNegativo") { InventarioSinStockNegativo = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "ListasDePreciosConImportesEnUMBasica") { ListasDePreciosConImportesEnUMBasica = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "PagosAutorizacionPreviaDeDocCompra") { PagosAutorizacionPreviaDeDocCompra = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "PagosConContabilidad") { PagosConContabilidad = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "PagosConImpuestos") { PagosConImpuestos = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "PagosConObservaciones") { PagosConObservaciones = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "Password") { Password = parametro.Valor }
            if (parametro.Parametro === "PedidosConCliente") { PedidosConCliente = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "PedidosConDetalle") { PedidosConDetalle = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "PedidosConImpuestos") { PedidosConImpuestos = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "PedidosConObservaciones") { PedidosConObservaciones = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "PedidosConPosibilidadDeAbono") { PedidosConPosibilidadDeAbono = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "PedidosPV1_UltimoGenerado") { PedidosPV1_UltimoGenerado = parametro.Valor }
            if (parametro.Parametro === "PedidosPV2_UltimoGenerado") { PedidosPV2_UltimoGenerado = parametro.Valor }
            if (parametro.Parametro === "PedidosPV3_UltimoGenerado") { PedidosPV3_UltimoGenerado = parametro.Valor }
            if (parametro.Parametro === "PedidosPV4_UltimoGenerado") { PedidosPV4_UltimoGenerado = parametro.Valor }
            if (parametro.Parametro === "PedidosPV5_UltimoGenerado") { PedidosPV5_UltimoGenerado = parametro.Valor }
            if (parametro.Parametro === "PedidosPV6_UltimoGenerado") { PedidosPV6_UltimoGenerado = parametro.Valor }
            if (parametro.Parametro === "PedidosPV7_UltimoGenerado") { PedidosPV7_UltimoGenerado = parametro.Valor }
            if (parametro.Parametro === "PedidosPV8_UltimoGenerado") { PedidosPV8_UltimoGenerado = parametro.Valor }
            if (parametro.Parametro === "PedidosPV9_UltimoGenerado") { PedidosPV9_UltimoGenerado = parametro.Valor }
            if (parametro.Parametro === "PedidosTiempoDeBorradoParaPedidosSinConfirmar") { PedidosTiempoDeBorradoParaPedidosSinConfirmar = parametro.Valor }
            if (parametro.Parametro === "PedidosValorizados") { PedidosValorizados = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "PermiteCrearRemitosDesdeVentas") { PermiteCrearRemitosDesdeVentas = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "Port") { Port = parametro.Valor }
            if (parametro.Parametro === "ProduccionCreaOTCuandoCreoPedido") { ProduccionCreaOTCuandoCreoPedido = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "ProduccionFabricacionImprimeEtiquetas") { ProduccionFabricacionImprimeEtiquetas = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "RecibosConContabilidad") { RecibosConContabilidad = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "RecibosConImpuestos") { RecibosConImpuestos = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "RecibosConObservaciones") { RecibosConObservaciones = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "RecibosPV1_UltimoGenerado") { RecibosPV1_UltimoGenerado = parametro.Valor }
            if (parametro.Parametro === "RecibosPV2_UltimoGenerado") { RecibosPV2_UltimoGenerado = parametro.Valor }
            if (parametro.Parametro === "RecibosPV3_UltimoGenerado") { RecibosPV3_UltimoGenerado = parametro.Valor }
            if (parametro.Parametro === "RecibosPV4_UltimoGenerado") { RecibosPV4_UltimoGenerado = parametro.Valor }
            if (parametro.Parametro === "RecibosPV5_UltimoGenerado") { RecibosPV5_UltimoGenerado = parametro.Valor }
            if (parametro.Parametro === "RecibosPV6_UltimoGenerado") { RecibosPV6_UltimoGenerado = parametro.Valor }
            if (parametro.Parametro === "RecibosPV7_UltimoGenerado") { RecibosPV7_UltimoGenerado = parametro.Valor }
            if (parametro.Parametro === "RecibosPV8_UltimoGenerado") { RecibosPV8_UltimoGenerado = parametro.Valor }
            if (parametro.Parametro === "RecibosPV9_UltimoGenerado") { RecibosPV9_UltimoGenerado = parametro.Valor }
            if (parametro.Parametro === "RemitosPV1_UltimoGenerado") { RemitosPV1_UltimoGenerado = parametro.Valor }
            if (parametro.Parametro === "RemitosPV2_UltimoGenerado") { RemitosPV2_UltimoGenerado = parametro.Valor }
            if (parametro.Parametro === "RemitosPV3_UltimoGenerado") { RemitosPV3_UltimoGenerado = parametro.Valor }
            if (parametro.Parametro === "RemitosPV4_UltimoGenerado") { RemitosPV4_UltimoGenerado = parametro.Valor }
            if (parametro.Parametro === "RemitosPV5_UltimoGenerado") { RemitosPV5_UltimoGenerado = parametro.Valor }
            if (parametro.Parametro === "RemitosPV6_UltimoGenerado") { RemitosPV6_UltimoGenerado = parametro.Valor }
            if (parametro.Parametro === "RemitosPV7_UltimoGenerado") { RemitosPV7_UltimoGenerado = parametro.Valor }
            if (parametro.Parametro === "RemitosPV8_UltimoGenerado") { RemitosPV8_UltimoGenerado = parametro.Valor }
            if (parametro.Parametro === "RemitosPV9_UltimoGenerado") { RemitosPV9_UltimoGenerado = parametro.Valor }
            if (parametro.Parametro === "RemitosValorizados") { RemitosValorizados = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "Server") { Server = parametro.Valor }
            if (parametro.Parametro === "SincronizaConDispositivosDesconectados") { SincronizaConDispositivosDesconectados = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "SincronizaConNube") { SincronizaConNube = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "UltimaSincronizacion") { UltimaSincronizacion = parametro.Valor }
            if (parametro.Parametro === "UltimaSubidaALaNube") { UltimaSubidaALaNube = parametro.Valor }
            if (parametro.Parametro === "Usuario") { Usuario = parametro.Valor }
            if (parametro.Parametro === "VentasBajaStockEnPuntoDeVentaSinImportarParametrizacionDeArticulo") { VentasBajaStockEnPuntoDeVentaSinImportarParametrizacionDeArticulo = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "VentasClienteConsumidorFinal") { VentasClienteConsumidorFinal = parametro.Valor }
            if (parametro.Parametro === "VentasCodigoArticuloFaltanteDeCaja") { VentasCodigoArticuloFaltanteDeCaja = parametro.Valor }
            if (parametro.Parametro === "VentasCodigoArticuloSobranteDeCaja") { VentasCodigoArticuloSobranteDeCaja = parametro.Valor }
            if (parametro.Parametro === "VentasConCliente") { VentasConCliente = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "VentasConContabilidad") { VentasConContabilidad = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "VentasConCosteo") { VentasConCosteo = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "VentasConDetalle") { VentasConDetalle = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "VentasConImpuestos") { VentasConImpuestos = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "VentasConObservaciones") { VentasConObservaciones = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "VentasCorreoDocVentaEnviaDetalleDeDeuda") { VentasCorreoDocVentaEnviaDetalleDeDeuda = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "VentasDesactivaCuentasFinancierasManualesSiFormaPagoNoEsEfectivo") { VentasDesactivaCuentasFinancierasManualesSiFormaPagoNoEsEfectivo = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "VentasDigitosDeRedondeoEnLPPorcentuales") { VentasDigitosDeRedondeoEnLPPorcentuales = parametro.Valor }
            if (parametro.Parametro === "VentasImporteGastadoParaObtenerUnPunto") { VentasImporteGastadoParaObtenerUnPunto = parametro.Valor }
            if (parametro.Parametro === "VentasImpresionDeFacturaElectronicaPorComandera") { VentasImpresionDeFacturaElectronicaPorComandera = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "VentasImprimeSinPreguntar") { VentasImprimeSinPreguntar = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "VentasImprimeTicketsComanderasEnArchivo") { VentasImprimeTicketsComanderasEnArchivo = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "VentasListaPreciosParaPuntoVenta") { VentasListaPreciosParaPuntoVenta = parametro.Valor }
            if (parametro.Parametro === "VentasNCConCliente") { VentasNCConCliente = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "VentasNCConContabilidad") { VentasNCConContabilidad = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "VentasNCConCosteo") { VentasNCConCosteo = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "VentasNCConDetalle") { VentasNCConDetalle = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "VentasNCConImpuestos") { VentasNCConImpuestos = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "VentasNCConObservaciones") { VentasNCConObservaciones = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "VentasNDConCliente") { VentasNDConCliente = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "VentasNDConContabilidad") { VentasNDConContabilidad = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "VentasNDConCosteo") { VentasNDConCosteo = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "VentasNDConDetalle") { VentasNDConDetalle = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "VentasNDConImpuestos") { VentasNDConImpuestos = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "VentasNDConObservaciones") { VentasNDConObservaciones = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "VentasObtienePrecioSugeridoDeVentaDesdeCosto") { VentasObtienePrecioSugeridoDeVentaDesdeCosto = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "VentasPedidosCodigoUbicacionReservaStock") { VentasPedidosCodigoUbicacionReservaStock = parametro.Valor }
            if (parametro.Parametro === "VentasPedidosUsaReservaStock") { VentasPedidosUsaReservaStock = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "VentasPermiteDocsVentaSinReciboDesdePV") { VentasPermiteDocsVentaSinReciboDesdePV = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "VentasPermiteReciboConImporteDiferenteAlDocVentaDesdePV") { VentasPermiteReciboConImporteDiferenteAlDocVentaDesdePV = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "VentasPV1_UltimoGenerado") { VentasPV1_UltimoGenerado = parametro.Valor }
            if (parametro.Parametro === "VentasPV2_UltimoGenerado") { VentasPV2_UltimoGenerado = parametro.Valor }
            if (parametro.Parametro === "VentasPV3_UltimoGenerado") { VentasPV3_UltimoGenerado = parametro.Valor }
            if (parametro.Parametro === "VentasPV4_UltimoGenerado") { VentasPV4_UltimoGenerado = parametro.Valor }
            if (parametro.Parametro === "VentasPV5_UltimoGenerado") { VentasPV5_UltimoGenerado = parametro.Valor }
            if (parametro.Parametro === "VentasPV6_UltimoGenerado") { VentasPV6_UltimoGenerado = parametro.Valor }
            if (parametro.Parametro === "VentasPV7_UltimoGenerado") { VentasPV7_UltimoGenerado = parametro.Valor }
            if (parametro.Parametro === "VentasPV8_UltimoGenerado") { VentasPV8_UltimoGenerado = parametro.Valor }
            if (parametro.Parametro === "VentasPV9_UltimoGenerado") { VentasPV9_UltimoGenerado = parametro.Valor }
            if (parametro.Parametro === "VentasPVArticulosConPeso") { VentasPVArticulosConPeso = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "VentasPVArticulosPuedeAbrirBuscador") { VentasPVArticulosPuedeAbrirBuscador = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "VentasPVConDatosExtraAlCrearCliente") { VentasPVConDatosExtraAlCrearCliente = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "VentasPVConGrupoDetalleDeVentas") { VentasPVConGrupoDetalleDeVentas = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "VentasPVConGrupoVerificaciones") { VentasPVConGrupoVerificaciones = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "VentasPVConTransferenciasAutomaticas") { VentasPVConTransferenciasAutomaticas = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "VentasPVFESinValidarLeyenda") { VentasPVFESinValidarLeyenda = parametro.Valor }
            if (parametro.Parametro === "VentasPVFESinValidarPermiteImprimir") { VentasPVFESinValidarPermiteImprimir = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "VentasPVPermiteVenderConPrecioCero") { VentasPVPermiteVenderConPrecioCero = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "VentasPVPermiteVisualizarEfectivoDeCaja") { VentasPVPermiteVisualizarEfectivoDeCaja = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "VentasPVProveedorDelivery1") { VentasPVProveedorDelivery1 = parametro.Valor }
            if (parametro.Parametro === "VentasPVProveedorDelivery1Activo") { VentasPVProveedorDelivery1Activo = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "VentasPVProveedorDelivery1CantidadDigitos") { VentasPVProveedorDelivery1CantidadDigitos = parametro.Valor }
            if (parametro.Parametro === "VentasPVProveedorDelivery1CuentaFinanciera") { VentasPVProveedorDelivery1CuentaFinanciera = parametro.Valor }
            if (parametro.Parametro === "VentasPVProveedorDelivery1ListaDePrecios") { VentasPVProveedorDelivery1ListaDePrecios = parametro.Valor }
            if (parametro.Parametro === "VentasPVProveedorDelivery2") { VentasPVProveedorDelivery2 = parametro.Valor }
            if (parametro.Parametro === "VentasPVProveedorDelivery2Activo") { VentasPVProveedorDelivery2Activo = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "VentasPVProveedorDelivery2CantidadDigitos") { VentasPVProveedorDelivery2CantidadDigitos = parametro.Valor }
            if (parametro.Parametro === "VentasPVProveedorDelivery2CuentaFinanciera") { VentasPVProveedorDelivery2CuentaFinanciera = parametro.Valor }
            if (parametro.Parametro === "VentasPVProveedorDelivery2ListaDePrecios") { VentasPVProveedorDelivery2ListaDePrecios = parametro.Valor }
            if (parametro.Parametro === "VentasPVProveedorDelivery3") { VentasPVProveedorDelivery3 = parametro.Valor }
            if (parametro.Parametro === "VentasPVProveedorDelivery3Activo") { VentasPVProveedorDelivery3Activo = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "VentasPVProveedorDelivery3CantidadDigitos") { VentasPVProveedorDelivery3CantidadDigitos = parametro.Valor }
            if (parametro.Parametro === "VentasPVProveedorDelivery3CuentaFinanciera") { VentasPVProveedorDelivery3CuentaFinanciera = parametro.Valor }
            if (parametro.Parametro === "VentasPVProveedorDelivery3ListaDePrecios") { VentasPVProveedorDelivery3ListaDePrecios = parametro.Valor }
            if (parametro.Parametro === "VentasPVProveedorDelivery4") { VentasPVProveedorDelivery4 = parametro.Valor }
            if (parametro.Parametro === "VentasPVProveedorDelivery4Activo") { VentasPVProveedorDelivery4Activo = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "VentasPVProveedorDelivery4CantidadDigitos") { VentasPVProveedorDelivery4CantidadDigitos = parametro.Valor }
            if (parametro.Parametro === "VentasPVProveedorDelivery4CuentaFinanciera") { VentasPVProveedorDelivery4CuentaFinanciera = parametro.Valor }
            if (parametro.Parametro === "VentasPVProveedorDelivery4ListaDePrecios") { VentasPVProveedorDelivery4ListaDePrecios = parametro.Valor }
            if (parametro.Parametro === "VentasPVProveedorDelivery5") { VentasPVProveedorDelivery5 = parametro.Valor }
            if (parametro.Parametro === "VentasPVProveedorDelivery5Activo") { VentasPVProveedorDelivery5Activo = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "VentasPVProveedorDelivery5CantidadDigitos") { VentasPVProveedorDelivery5CantidadDigitos = parametro.Valor }
            if (parametro.Parametro === "VentasPVProveedorDelivery5CuentaFinanciera") { VentasPVProveedorDelivery5CuentaFinanciera = parametro.Valor }
            if (parametro.Parametro === "VentasPVProveedorDelivery5ListaDePrecios") { VentasPVProveedorDelivery5ListaDePrecios = parametro.Valor }
            if (parametro.Parametro === "VentasPVProveedorDelivery6") { VentasPVProveedorDelivery6 = parametro.Valor }
            if (parametro.Parametro === "VentasPVProveedorDelivery6Activo") { VentasPVProveedorDelivery6Activo = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "VentasPVProveedorDelivery6CantidadDigitos") { VentasPVProveedorDelivery6CantidadDigitos = parametro.Valor }
            if (parametro.Parametro === "VentasPVProveedorDelivery6CuentaFinanciera") { VentasPVProveedorDelivery6CuentaFinanciera = parametro.Valor }
            if (parametro.Parametro === "VentasPVProveedorDelivery6ListaDePrecios") { VentasPVProveedorDelivery6ListaDePrecios = parametro.Valor }
            if (parametro.Parametro === "VentasRappiEnProduccion") { VentasRappiEnProduccion = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "VentasRedondeoAMultiplosDeCinco") { VentasRedondeoAMultiplosDeCinco = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "VentasUsaCodigosBarra") { VentasUsaCodigosBarra = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "VentasValidaFESinPreguntar") { VentasValidaFESinPreguntar = TratamientoDeVariableBoolean(parametro.Valor) }
            if (parametro.Parametro === "VentasWebIdUsuario") { VentasWebIdUsuario = parametro.Valor }
            if (parametro.Parametro === "VentasWebTerminal") { VentasWebTerminal = parametro.Valor }
            if (parametro.Parametro === "ViafarUltimaCompraImportada") { ViafarUltimaCompraImportada = parametro.Valor }
        });
    } catch (error) {
        throw error;
    }

    return {
        CodigoArticuloComisionMercadoPago,
        CodigoArticuloEnvioMercadoPago,
        CodigoCuentaFinancieraMercadoPago,
        CodigoDepositoParaReservasDePedidosDeVenta,
        CodigoPresentacionComisionMercadoPago,
        CodigoSubCCComisionMercadoPago,
        CodigoTamanoComisionMercadoPago,
        CodigoUnidadMedidaComisionMercadoPago,
        ComprasComisionesArticulo,
        ComprasComisionesPresentacion,
        ComprasComisionesSubCC,
        ComprasComisionesTamano,
        ComprasComisionesUbicacion,
        ComprasComisionesUnidadMedida,
        ComprasConContabilidad,
        ComprasConCosteo,
        ComprasConDetalle,
        ComprasConImpuestos,
        ComprasConObservaciones,
        ComprasConProveedor,
        ComprasNCConContabilidad,
        ComprasNCConCosteo,
        ComprasNCConDetalle,
        ComprasNCConImpuestos,
        ComprasNCConObservaciones,
        ComprasNCConProveedor,
        ComprasNDConContabilidad,
        ComprasNDConCosteo,
        ComprasNDConDetalle,
        ComprasNDConImpuestos,
        ComprasNDConObservaciones,
        ComprasNDConProveedor,
        ComprasPermiteDocsCompraSinPagoDesdePC,
        ComprasPermitePagoConImporteDiferenteAlDocCompraDesdePC,
        ContabilidadConAsientos,
        ContabilidadConvenioMultilateral,
        ContabilidadIVA10ComprasCodigoCuentaContable,
        ContabilidadIVA10VentasCodigoCuentaContable,
        ContabilidadIVA21ComprasCodigoCuentaContable,
        ContabilidadIVA21VentasCodigoCuentaContable,
        ContabilidadIVA27ComprasCodigoCuentaContable,
        ContabilidadIVA27VentasCodigoCuentaContable,
        ContabilidadPercepcionesIIBBPorPadron,
        ContabilidadRetencionesIIBBPorPadron,
        CorreoAEnviarConfirmacionLectura,
        CorreoAEnviarCopia,
        CorreoEmisor,
        CotizacionesConCliente,
        CotizacionesConDetalle,
        CotizacionesConImpuestos,
        CotizacionesConObservaciones,
        DesconectadoActualizaSiempreAlIngresar,
        EnProcesoDeSincronizacioConDesconectados,
        EnProcesoDeSincronizacioConNube,
        GlobalAdminSinAjusteDeInventario,
        GlobalCantidadBuscadorFiltro,
        GlobalCantidadListadosMaestros,
        GlobalCantidadListadosOperaciones,
        GlobalCierraVentanasAlFinalizarEdicion,
        GlobalConAuditoria,
        GlobalConPacientes,
        GlobalControlHorarioClientesRequiereSalida,
        GlobalControlHorarioPersonasRequiereSalida,
        GlobalDiasGraciaDeBorradoRemitos,
        GlobalDigitosDeVisualizacionEnCantidadesDeCompra,
        GlobalDigitosDeVisualizacionEnCantidadesDeVenta,
        GlobalEstiloColores,
        GlobalEstiloColoresPersonalizado,
        GlobalFechaBloqueadaDocsCompra,
        GlobalFechaBloqueadaDocsVenta,
        GlobalFechaBloqueadaPagos,
        GlobalFechaBloqueadaRecibos,
        GlobalFechaBloqueadaRemitos,
        GlobalFechaReportes,
        GlobalFechaUltimoBackUp,
        GlobalMonedaBase,
        GlobalMonedaReferente,
        GlobalNoFiltraHastaNoPresionarActualizar,
        GlobalPathBackUp,
        GlobalPrefijoCodigoBarras,
        GlobalRemitosTransferenciaSeGeneranPendientesDeConfirmar,
        GlobalSoloAdminBorraEditaDocsCompra,
        GlobalSoloAdminBorraEditaDocsVenta,
        GlobalSoloAdminBorraEditaPagos,
        GlobalSoloAdminBorraEditaRecibos,
        GlobalSoloAdminBorraEditaRemitos,
        GlobalToleranciaDeRedondeoEnOperaciones,
        GlobalUsaArticulosConCodigoEnLasGrillas,
        GlobalUsaArticulosConPresentacion,
        GlobalUsaArticulosConTamano,
        GlobalUsaArticulosConUnidadDeMedida,
        GlobalVersionMasAltaLogeada,
        IdProveedorMercadoPago,
        IntervaloDeSincronizacion,
        InventarioSinStockNegativo,
        ListasDePreciosConImportesEnUMBasica,
        PagosAutorizacionPreviaDeDocCompra,
        PagosConContabilidad,
        PagosConImpuestos,
        PagosConObservaciones,
        Password,
        PedidosConCliente,
        PedidosConDetalle,
        PedidosConImpuestos,
        PedidosConObservaciones,
        PedidosConPosibilidadDeAbono,
        PedidosPV1_UltimoGenerado,
        PedidosPV2_UltimoGenerado,
        PedidosPV3_UltimoGenerado,
        PedidosPV4_UltimoGenerado,
        PedidosPV5_UltimoGenerado,
        PedidosPV6_UltimoGenerado,
        PedidosPV7_UltimoGenerado,
        PedidosPV8_UltimoGenerado,
        PedidosPV9_UltimoGenerado,
        PedidosTiempoDeBorradoParaPedidosSinConfirmar,
        PedidosValorizados,
        PermiteCrearRemitosDesdeVentas,
        Port,
        ProduccionCreaOTCuandoCreoPedido,
        ProduccionFabricacionImprimeEtiquetas,
        RecibosConContabilidad,
        RecibosConImpuestos,
        RecibosConObservaciones,
        RecibosPV1_UltimoGenerado,
        RecibosPV2_UltimoGenerado,
        RecibosPV3_UltimoGenerado,
        RecibosPV4_UltimoGenerado,
        RecibosPV5_UltimoGenerado,
        RecibosPV6_UltimoGenerado,
        RecibosPV7_UltimoGenerado,
        RecibosPV8_UltimoGenerado,
        RecibosPV9_UltimoGenerado,
        RemitosPV1_UltimoGenerado,
        RemitosPV2_UltimoGenerado,
        RemitosPV3_UltimoGenerado,
        RemitosPV4_UltimoGenerado,
        RemitosPV5_UltimoGenerado,
        RemitosPV6_UltimoGenerado,
        RemitosPV7_UltimoGenerado,
        RemitosPV8_UltimoGenerado,
        RemitosPV9_UltimoGenerado,
        RemitosValorizados,
        Server,
        SincronizaConDispositivosDesconectados,
        SincronizaConNube,
        UltimaSincronizacion,
        UltimaSubidaALaNube,
        Usuario,
        VentasBajaStockEnPuntoDeVentaSinImportarParametrizacionDeArticulo,
        VentasClienteConsumidorFinal,
        VentasCodigoArticuloFaltanteDeCaja,
        VentasCodigoArticuloSobranteDeCaja,
        VentasConCliente,
        VentasConContabilidad,
        VentasConCosteo,
        VentasConDetalle,
        VentasConImpuestos,
        VentasConObservaciones,
        VentasCorreoDocVentaEnviaDetalleDeDeuda,
        VentasDesactivaCuentasFinancierasManualesSiFormaPagoNoEsEfectivo,
        VentasDigitosDeRedondeoEnLPPorcentuales,
        VentasImporteGastadoParaObtenerUnPunto,
        VentasImpresionDeFacturaElectronicaPorComandera,
        VentasImprimeSinPreguntar,
        VentasImprimeTicketsComanderasEnArchivo,
        VentasListaPreciosParaPuntoVenta,
        VentasNCConCliente,
        VentasNCConContabilidad,
        VentasNCConCosteo,
        VentasNCConDetalle,
        VentasNCConImpuestos,
        VentasNCConObservaciones,
        VentasNDConCliente,
        VentasNDConContabilidad,
        VentasNDConCosteo,
        VentasNDConDetalle,
        VentasNDConImpuestos,
        VentasNDConObservaciones,
        VentasObtienePrecioSugeridoDeVentaDesdeCosto,
        VentasPedidosCodigoUbicacionReservaStock,
        VentasPedidosUsaReservaStock,
        VentasPermiteDocsVentaSinReciboDesdePV,
        VentasPermiteReciboConImporteDiferenteAlDocVentaDesdePV,
        VentasPV1_UltimoGenerado,
        VentasPV2_UltimoGenerado,
        VentasPV3_UltimoGenerado,
        VentasPV4_UltimoGenerado,
        VentasPV5_UltimoGenerado,
        VentasPV6_UltimoGenerado,
        VentasPV7_UltimoGenerado,
        VentasPV8_UltimoGenerado,
        VentasPV9_UltimoGenerado,
        VentasPVArticulosConPeso,
        VentasPVArticulosPuedeAbrirBuscador,
        VentasPVConDatosExtraAlCrearCliente,
        VentasPVConGrupoDetalleDeVentas,
        VentasPVConGrupoVerificaciones,
        VentasPVConTransferenciasAutomaticas,
        VentasPVFESinValidarLeyenda,
        VentasPVFESinValidarPermiteImprimir,
        VentasPVPermiteVenderConPrecioCero,
        VentasPVPermiteVisualizarEfectivoDeCaja,
        VentasPVProveedorDelivery1,
        VentasPVProveedorDelivery1Activo,
        VentasPVProveedorDelivery1CantidadDigitos,
        VentasPVProveedorDelivery1CuentaFinanciera,
        VentasPVProveedorDelivery1ListaDePrecios,
        VentasPVProveedorDelivery2,
        VentasPVProveedorDelivery2Activo,
        VentasPVProveedorDelivery2CantidadDigitos,
        VentasPVProveedorDelivery2CuentaFinanciera,
        VentasPVProveedorDelivery2ListaDePrecios,
        VentasPVProveedorDelivery3,
        VentasPVProveedorDelivery3Activo,
        VentasPVProveedorDelivery3CantidadDigitos,
        VentasPVProveedorDelivery3CuentaFinanciera,
        VentasPVProveedorDelivery3ListaDePrecios,
        VentasPVProveedorDelivery4,
        VentasPVProveedorDelivery4Activo,
        VentasPVProveedorDelivery4CantidadDigitos,
        VentasPVProveedorDelivery4CuentaFinanciera,
        VentasPVProveedorDelivery4ListaDePrecios,
        VentasPVProveedorDelivery5,
        VentasPVProveedorDelivery5Activo,
        VentasPVProveedorDelivery5CantidadDigitos,
        VentasPVProveedorDelivery5CuentaFinanciera,
        VentasPVProveedorDelivery5ListaDePrecios,
        VentasPVProveedorDelivery6,
        VentasPVProveedorDelivery6Activo,
        VentasPVProveedorDelivery6CantidadDigitos,
        VentasPVProveedorDelivery6CuentaFinanciera,
        VentasPVProveedorDelivery6ListaDePrecios,
        VentasRappiEnProduccion,
        VentasRedondeoAMultiplosDeCinco,
        VentasUsaCodigosBarra,
        VentasValidaFESinPreguntar,
        VentasWebIdUsuario,
        VentasWebTerminal,
        ViafarUltimaCompraImportada
    };
}

export function TratamientoDeParametroParaURI(Parametro) {
    let ParametroModificado = ""
    if (Parametro !== undefined && Parametro !== null) {
        ParametroModificado = String(Parametro);
    }

    try {
        ParametroModificado = ParametroModificado.replace(/\%/g, "%25"); //Este siempre tiene que ser el primero
        ParametroModificado = ParametroModificado.replace(/\ /g, "%20"); //Reemplaza el ESPACIO
        ParametroModificado = ParametroModificado.replace(/\//g, "%2F");
        ParametroModificado = ParametroModificado.replace(/\\/g, "%22");
        ParametroModificado = ParametroModificado.replace(/\'/g, "%27");
        ParametroModificado = ParametroModificado.replace(/\*/g, "%2A");

        if (ParametroModificado == "") {
            ParametroModificado = "NA*DA"; //tiene que ser el ultimo
        }
    }
    catch (error) {
        throw error;
    }

    return ParametroModificado;
}

export function ConversionDeExcelToJson(ws) {
    let excelData

    try {
        excelData = XLSX.utils.sheet_to_json(ws, { header: 0 });

    } catch (error) {
    }

    return excelData;
}

export const ConversionarrayBufferToBase64 = (buffer) => {
    let binary = '';
    const bytes = new Uint8Array(buffer);
    for (let i = 0; i < bytes.byteLength; i++) {
        binary += String.fromCharCode(bytes[i]);
    }
    return btoa(binary);
};
